import moment from '@/moment-gp'

export function guess_timezone() {
  // This needs improvment. Usually we create the user via CLI or soon with a
  // admin tool, but then we don't want to set the users timezone to our timezone
  // Possible solutions:
  // - Set timezone on first login
  // - Allow user to create basic profile and save timezone (Security Rules)
  if ( process.browser ) {
    // const moment = require('../../moment-gp')
    return moment.tz.guess()
  } else {
    return "Europe/Berlin"
  }
}
